import userStore from "./userStore";

const getters = {
  collegeInfo: state => state.baseConfig.collegeInfo,
  parkInfo: state => state.baseConfig.parkInfo,
  access_token: state => state.userStore.access_token,
  refresh_token: state => state.userStore.refresh_token,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js